<template>
  <div class="card collapse-item" :class="{ 'is-fullwidth': $parent.isFullwidth, 'is-active': isActive }">
    <header class="card-header touchable" role="tab" :aria-expanded="selected ? 'true' : 'false'" @click="toggle">
      <h3 class="card-header-title">{{ title }}</h3>
      <span class="card-header-icon">
        <i class="mdi mdi-chevron-right"></i>
      </span>
    </header>
    <div class="card-content" v-show="isActive">
      <div class="card-content-box">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  import anime from 'animejs'

  export default {
    name: 'collapse-item',
    props: {
      selected: Boolean,
      title: {
        type: String,
        required: true
      },
      itemId: {
        type: [String, Number]
      }
    },

    data () {
      return {
        isActive: this.selected
      }
    },

    created () {
      this._isCollapseItem = true
    },

    mounted () {
      this.$on('open', this.$parent.openByIndex)
      if (this.isActive) {
        this.$emit('open', this.index)
      }
    },

    beforeDestroy () {
      if (this.anime && this.targets) {
        anime.remove(this.targets)
      }
      this.$off('open', this.$parent.openByIndex)
    },

    computed: {
      index () {
        return this.$parent.$collapseItems.indexOf(this)
      }
    },

    methods: {
      toggle () {
        this.isActive = !this.isActive
        this.$emit('open', this.index)
        this.$emit('toggled', this)
      },

      cancel () {
        this.anime.pause()
      },

      before (targets) {
        if (!this.targets) this.targets = targets
        targets.removeAttribute('style')
      },

      enter (targets, done) {
        const height = targets.scrollHeight
        targets.style.height = 0
        this.anime = anime({
          targets: targets,
          duration: 1000,
          height: [0, height],
          opacity: [0, 1],
          easing: 'easeOutExpo',
          complete: () => {
            targets.removeAttribute('style')
            this.focusInput()
            done()
          }
        })
      },

      leave (targets, complete) {
        this.anime = anime({
          targets: targets,
          duration: 377,
          height: 0,
          opacity: [1, 0],
          easing: 'easeOutExpo',
          complete
        })
      },

      focusInput () {
        if (this.targets) {
          let target = this.targets.getElementsByTagName('textarea')[0] || this.targets.getElementsByTagName('input')[0]
          target && target.focus()
        }
      }
    }
  }
</script>

<style lang="sass" scoped>
.collapse-item
  .card-header
    cursor: pointer

  .card-header-icon
    text-align: center
    i
     width: 21px
     transition: transform .377s ease
     transform-origin: 50% 50%

  .card-content
    padding-top: 0
    padding-bottom: 0
    overflow: hidden

  .card-content-box
    padding-top: 20px
    padding-bottom: 20px

  &.is-active
    > .card-header
      > .card-header-icon
        i
         transform: rotate(90deg)
</style>
